import { MprcContainer } from "components";
import Carousel from "components/MprcCarousel/Carousel";
import { BannerResponse } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import { useCallback, useEffect, useState } from "react";
import { BannerRender } from "./BannerRender";

type IProps = {
    pageView: number;
    margin?: MprcMargin;
};


export const BannerCarousel = ({ pageView, margin }: IProps) => {
    const api = useCoreApi();
    const [listData, setListData] = useState<BannerResponse[]>([]);
    const [currentBannerIndex, setCurrentBannerIndex] = useState<number>(0);


    ////////////////////////////////////////////////////////////////////////////
    /// USEEFFECT
    ////////////////////////////////////////////////////////////////////////////

    async function getData() {
        try {
            var result = await api.v1.banner.getBanners({ bannerId: null, pageNumber: 1, pageSize: 100, pageView: pageView });
            setListData(result.data.items);
        }
        catch (e) {
            console.error(e);
        }
    }

    /// ao iniciar
    useEffect(() => {
        getData();
    }, []);
    ///
    const updateOwnProps = useCallback((index: number) => {

    }, []);

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    if (listData.length == 0) return null;

    ///
    return (
        <MprcContainer margin={margin}>
            <Carousel
                index={currentBannerIndex}
                className="carousel"
                fullHeightHover={false}
                autoPlay={listData.length > 0 && listData[0].rotationAutomatic ? true : false}
                interval={listData.length > 0 && listData[0].rotationAutomatic ? listData[0].interval! * 1000 : undefined}
                indicators={listData.length > 1}
                navButtonsAlwaysInvisible
                onChange={
                    (now, previous) => {
                        setCurrentBannerIndex(now!);
                        updateOwnProps(now!);
                    }
                }
            >
                {
                    listData.map((banner, index) => (
                        <div key={index}>
                            <BannerRender key={index} viewData={banner} />
                        </div>
                    ))
                }
            </Carousel>
        </MprcContainer>

    );
};
